// @flow
import React, { Component } from "react";
import { GlobalProvider } from "../common/GlobalContext";

import type {
  $Site,
  $SiteOffice,
  $Agent,
  $Team,
  ComplianceItems as $ComplianceItems,
} from "flow/types";

import RightSideNav from "./Headers/RightSideNav";
import DefaultNav from "./Headers/DefaultNav";
import StickyHeader from "./StickyHeader";
import ThreeColumnNavBar from "./Headers/ThreeColumnNavBar";
import OfficeLogoRightNavBar from "./Headers/OfficeLogoRightNavBar";

type $Props = {
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: string,
  agent?: $Agent,
  compliance: $ComplianceItems,
  favorites: Object,
  headerNav: string,
  office?: $SiteOffice,
  pathName: string,
  site: $Site,
  siteUser: Object,
  team?: $Team,
  theme: Object,
};

class Header extends Component<$Props> {
  // renders the correct header
  renderHeader = () => {
    const headerNav = this.props.headerNav ? this.props.headerNav : "default";
    const { site } = this.props;

    if (
      site.productType !== "idx-free" &&
      headerNav === "agentImageRightSideNavBar"
    ) {
      return <RightSideNav />;
    } else if (site.productType !== "idx-free" && headerNav === "default") {
      return <DefaultNav />;
    } else if (
      site.productType !== "idx-free" &&
      headerNav === "threeColumnNavBar"
    ) {
      return <ThreeColumnNavBar />;
    } else if (
      site.productType !== "idx-free" &&
      headerNav === "officeLogoRightSideNavBar"
    ) {
      return <OfficeLogoRightNavBar />;
    } else {
      return <DefaultNav />;
    }
  };

  render() {
    const {
      RECAPTCHA_CLIENT,
      RECAPTCHA_CLIENT_V2,
      agent,
      compliance,
      favorites,
      headerNav,
      office,
      pathName,
      site,
      siteUser,
      team,
      theme,
    } = this.props;

    if (!(agent || team || office)) {
      return null;
    }
    return (
      <GlobalProvider
        RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
        RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
        agent={agent}
        compliance={compliance}
        favorites={favorites}
        headerNav={headerNav}
        office={office}
        pathName={pathName}
        site={site}
        siteUser={siteUser}
        team={team}
        theme={theme}
        withStyleReset={false}
      >
        {compliance &&
        (compliance.stickyHeader ||
          compliance.stickyHeaderCustom ||
          compliance.stickyHeaderMobile) ? (
          <StickyHeader />
        ) : null}
        {this.renderHeader()}
      </GlobalProvider>
    );
  }
}

export default Header;
